export default {
    data () {
        return {
            price: null,
            min: 0,
            max: 10000,
            step: 100
        }
    },

    created () {
    },

    async mounted () {
        if (!this.$refs.price) return
        if (this.$refs.price.value) {
            this.price = this.$refs.price.value.split(',')
        } else {
            this.price = [this.min, this.max]
        }

        var priceSlider  = document.getElementById('price-slider');

        if (priceSlider == null) return;

        var a = noUiSlider.create(priceSlider, {
            start: this.price,
            connect: true,
            step: this.step,
            range: {
                'min': this.min,
                'max': this.max
            },
        });

        // Update Price Range
        priceSlider.noUiSlider.on('update', function( values, handle ){
            var values = values.map(function (x) {return x.replace('.00', '')})
            $('#filter-price-range').text(values.join(' - '));
        });
    },

    methods: {
        submit () {
            var price = this.$el.querySelector('#filter-price-range').innerHTML
            this.$refs.price.value = price.replace(/ |　/g, '').replace(/\-/, ',')

            this.$nextTick(function () {
                this.$refs.filterForm.submit()
            })
        },
    },
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixin/side-filter-methods.js